import { InputField } from "../AddPatientGroup.style";
import * as React from "react";
import { useTranslation } from "hhn-commons";

export const InputPatientTag = ({
  meta,
  setMeta,
}: {
  meta: any;
  setMeta: any;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "patientGroup" });
  return (
    <InputField
      id="patient-tag"
      label={tNs("patientTagLabel")}
      type="text"
      variant="standard"
      value={meta}
      slotProps={{
        htmlInput: {
          "data-testid": "patient-tag",
          maxLength: 50,
        },
      }}
      onChange={e => {
        setMeta(e.target.value);
      }}
    />
  );
};
